import React from "react";
import PropTypes from "prop-types";
import { isBeforeNow, gridPosToDateSingleDay } from "../scheduler-helpers";
import moment from "moment";
import { TimeSlotContextDay } from "./use-availabilitySchedulerDay";

const TIME_SLOTS = Array.from(Array(60).keys());

const TimeSlot = React.memo(
  ({ row, col, selectedDate, timeZone, coachAvailability }) => {
    const isBetweenWorkingTime = (coachAvailability, value) => {
      const DayFromGridPosition = value.day();
      const schedulesThatDay = coachAvailability?.filter(
        x => x.day === DayFromGridPosition
      );
      if (!schedulesThatDay || schedulesThatDay.length == 0) return false;

      let { start, end, lunch_start, lunch_end } = schedulesThatDay[0];

      const TimeFromGridPosition = value.format("HH:mm");
      start = moment(start, "hh:mm a").format("HH:mm");
      end = moment(end, "hh:mm a").format("HH:mm");
      lunch_start = moment(lunch_start, "hh:mm a").format("HH:mm");
      lunch_end = moment(lunch_end, "hh:mm a").format("HH:mm");

      const isLunchTime =
        lunch_start <= TimeFromGridPosition && TimeFromGridPosition < lunch_end;
      const isWorkingTime =
        start <= TimeFromGridPosition && TimeFromGridPosition < end;

      if (isLunchTime) {
        return "lunch";
      } else if (isWorkingTime) {
        return "work";
      } else {
        return false;
      }
    };
    const isMiddleOfLunchTime = (coachAvailability, value) => {
      const DayFromGridPosition = value.day();
      const schedulesThatDay = coachAvailability?.filter(
        x => x.day === DayFromGridPosition
      );
      if (!schedulesThatDay || schedulesThatDay?.length == 0) return false;

      let { lunch_start, lunch_end } = schedulesThatDay[0];

      const TimeFromGridPosition = moment(value);
      lunch_start = moment(lunch_start, "hh:mm a");
      lunch_end = moment(lunch_end, "hh:mm a");

      const diffBetweenStartAndEnd = lunch_end.diff(lunch_start, "minutes");
      const diffIn15MinutesBlock =
        Math.round(Math.round(diffBetweenStartAndEnd / 15) / 2) * 15;
      const roundedDiff = diffIn15MinutesBlock - 15;
      const middleTime = lunch_start.clone().add(roundedDiff, "minutes");
      const currRowIsMiddleTime =
        TimeFromGridPosition.format("HH:mm") == middleTime.format("HH:mm");

      if (currRowIsMiddleTime) {
        return true;
      } else {
        return false;
      }
    };
    const { selected } = React.useContext(TimeSlotContextDay);
    const isSelected = selected?.row1 === row && selected?.col === col;
    const disabled = isBeforeNow(
      gridPosToDateSingleDay(row, selectedDate, timeZone)
    );
    const isWorkOrLunchTime =
      !disabled &&
      isBetweenWorkingTime(
        coachAvailability,
        gridPosToDateSingleDay(row, selectedDate, timeZone)
      );
    const isMiddleOfLunch =
      isWorkOrLunchTime == "lunch" &&
      isMiddleOfLunchTime(
        coachAvailability,
        gridPosToDateSingleDay(row, selectedDate, timeZone)
      );

    return (
      <div
        style={{
          gridRow: row + 1
        }}
        className={`time-slot ${isSelected ? "initial-row" : ""} ${disabled ? "disabled" : ""
          }
          ${isWorkOrLunchTime == "work" ? "work-time" : ""}
          ${isWorkOrLunchTime == "lunch" ? "lunch-time" : ""}
        `}
      >
        <p style={{ textAlign: "center" }}>{isMiddleOfLunch && "Lunch"}</p>
      </div>
    );
  }
);

TimeSlot.propTypes = {
  row: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  selectedDate: PropTypes.string.isRequired,
  timeZone: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  coachAvailability: PropTypes.array
};

const TimeSlotsDay = React.memo(
  ({ selectedDate, timeZone, coachAvailability }) =>
    TIME_SLOTS.map(row => (
      <TimeSlot
        key={`0-${row}`}
        row={row}
        col={0}
        selectedDate={selectedDate}
        timeZone={timeZone}
        coachAvailability={coachAvailability}
      />
    ))
);

TimeSlotsDay.propTypes = {
  startRow: PropTypes.number,
  selectedDate: PropTypes.string.isRequired,
  timeZone: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  coachAvailability: PropTypes.array
};

export default TimeSlotsDay;
